import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FormatBoldIcon(props: IconProps) {
    return <Icon {...props} iconKey={"format_bold"}/>
}
